var _defs, _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillForEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M21.16 29.72l11.08-11.08 5.17 5.17-11.09 11.08-7.38 2.22 2.22-7.39zM21.16 29.72l5.17 5.17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M21.16 29.72l11.08-11.08 5.17 5.17-11.09 11.08-7.38 2.22 2.22-7.39zM21.16 29.72l5.17 5.17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M19.33 12.57h6.21M14.09 18.85h8.36"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 14.09,
    cy: 12.57,
    r: 1.66
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M31.2 13.15V10.8c0-2.68-2.17-4.85-4.85-4.85H13.27c-2.68 0-4.85 2.17-4.85 4.85v18.15c0 2.68 2.17 4.85 4.85 4.85h.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillForEmployee);
export default __webpack_public_path__ + "static/media/fillForEmployee.818f308aab87917844c200ad1182b64c.svg";
export { ForwardRef as ReactComponent };